@if (initialized) {
  <div>
    <div class="header flex justify-between items-start">
      <div class="left">
        <div class="mat-headline-4">Site {{dailyReport.site.name}}</div>
        <div class="mat-headline-6">{{dailyReport.report_date | dateFormat: 'long' }}</div>
      </div>
      @if (dailyReport.status === 'draft') {
        <div class="right">
          <mat-icon class="menu-icon" [matMenuTriggerFor]="menu">more_horiz</mat-icon>
          <mat-menu #menu="matMenu">
            <button mat-menu-item class="delete-menu" (click)="deleteReport()">
              <mat-icon class="trash-icon" svgIcon="trash"/>
              <div class="menu-label text-type-8">Delete daily report</div>
            </button>
          </mat-menu>
        </div>
      }
    </div>
    <mat-tab-group>
      <mat-tab label="Daily report">
        <ng-template matTabContent>
          <div class="tab-content">
            <!-- Report Items -->
            <app-project-consolidated-report
              [dailyReport]="dailyReport"
              [editable]="('create' | able: dailyReport)"
              (dailyReportChange)="onDailyReportChange($event)"
            ></app-project-consolidated-report>
            @if (dailyReport.id && ('read' | able: dailyReport) && ('execute' | able: 'Workflow')) {
              @for (workflow of dailyReport['next-actions']; track workflow) {
                <app-workflow
                  [wf]="workflow.name"
                  [actions]="workflow.actions"
                  [id]="dailyReport.id"
                  [projectId]="dailyReport.project.id"
                  (actionResponse)="dailyReportChanged($event)"
                  [redraw]="dailyReport.status"
                ></app-workflow>
              }
            }
            <!-- /Report Items -->
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="Report history">
        <ng-template matTabContent>
          @if (workflowEx) {
            <app-workflow-lineage
              [ex]="workflowEx">
            </app-workflow-lineage>
          }
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
}
